@if (activeIdentity$ | async; as activeIdentity) {
  @if (!!activeIdentity && (isMaintenanceRoute$ | async) === false && (isErrorPageRoute$ | async) === false) {
    <app-new-layout></app-new-layout>
  } @else {
    <!-- Render default outlet for error pages or maintenance mode -->
    <router-outlet></router-outlet>
  }
}
<!-- auxiliary outlet targeted by fullscreen security components e.g. sign-in -->
<router-outlet name="top"></router-outlet>
